// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

// Get user ID from meta tag (add this to your layout)
const userId = document.querySelector('meta[name="user-id"]')?.content

// Connect with user ID as parameter
const consumer = createConsumer(`/cable?user_id=${userId}`)

// Expose globally so inline view scripts can create subscriptions
// (e.g. LocationTrackingChannel subscribed only while Track modal is open)
window.App = window.App || {}
window.App.cable = consumer

export default consumer